import { render } from "./APPFooter.vue?vue&type=template&id=90f468ca&scoped=true"
import script from "./APPFooter.vue?vue&type=script&lang=js"
export * from "./APPFooter.vue?vue&type=script&lang=js"

import "./APPFooter.vue?vue&type=style&index=0&id=90f468ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f468ca"]])

export default __exports__